import Controller from '@ember/controller'
import { tracked } from '@glimmer/tracking'

export class RexLessonPerformanceController extends Controller {
  queryParams = ['selectedLesson', 'sort', 'pageNumber', 'perPage']

  @tracked selectedLesson = 1

  @tracked sort = 'best_score'

  @tracked pageNumber = 1

  @tracked perPage = 25
}

export default RexLessonPerformanceController
